import AOS from 'aos';

AOS.init({
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'animated__animated'
});
